<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <v-toolbar-title v-if="orden.id">
                            <h3>Editar obra: {{ orden.nro_orden }}</h3>
                        </v-toolbar-title>
                        <v-toolbar-title v-else>
                            <h3>Crear obra</h3>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-form class="mt-3" ref="form">
                        <v-row style="margin-bottom: 1rem">
                            <v-col cols="6">
                                <v-tooltip right style="margin-bottom: 5px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab
                                            @click="redirect"
                                            :loading="isloading"
                                            :disabled="isloading"
                                            color="blue"
                                            class="mt-4 mx-3"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon class="white--text"
                                                >mdi-arrow-left-bold-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Volver</span>
                                </v-tooltip>

                                <!-- Mostrar botón de nuevo fichaje en el tab de fichajes -->
                                <v-tooltip right v-if="tab == 4">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab
                                            @click="openFormOrdenFichaje"
                                            :loading="isloading"
                                            color="success"
                                            class="mt-4"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon class="white--text"
                                                >mdi-plus</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Nuevo</span>
                                </v-tooltip>
                            </v-col>
                            <!--- <v-col
                                v-if="
                                    orden.fichajes != null &&
                                    (rol == 6 || rol == 7)
                                "
                                cols="6"
                                align-self="end"
                                style="display: flex; justify-content: end"
                            >
                                <v-btn
                                    v-if="orden.fichajes_count % 2 == 0"
                                    fab
                                    @click="Fichar(false)"
                                    :loading="isloading"
                                    :disabled="isloading"
                                    color="green"
                                    class="mt-2"
                                >
                                    <v-icon class="white--text"
                                        >mdi-play</v-icon
                                    >
                                </v-btn>
                                <template v-else>
                                    <v-btn
                                        fab
                                        @click="Fichar(false)"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="orange"
                                        class="mt-2"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-pause</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        fab
                                        @click="Fichar(true)"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="red"
                                        class="mt-2"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-stop</v-icon
                                        >
                                    </v-btn>
                                </template>
                            </v-col> -->
                        </v-row>

                        <v-tabs v-model="tab">
                            <!-- Datos -->
                            <v-tab>Datos</v-tab>
                            <v-tab-item>
                                <v-row class="mt-3">
                                    <!-- <v-col cols="12" md="3">
                                        <v-autocomplete
                                            :rules="[rules.required]"
                                            :readonly="readonlyinput"
                                            label="Tipo"
                                            v-model="orden.id_tipo"
                                            item-text="nombre"
                                            item-value="id"
                                            :items="tipos"
                                        >
                                        </v-autocomplete>
                                    </v-col> -->
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            v-model="orden.nombre"
                                            label="Nombre"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <cliente-select
                                            :rules="[rules.required]"
                                            v-model="orden.id_cliente"
                                            label="Cliente"
                                            :extra="orden.cliente"
                                            :readonly="readonlyinput"
                                        ></cliente-select>
                                    </v-col>
                                    <!-- <v-col cols="12" md="3">
                                        <v-autocomplete
                                            :readonly="readonlyinput"
                                            v-if="
                                                (orden.taller == 1) &
                                                (orden.lacado == 1)
                                            "
                                            label="Estado"
                                            v-model="orden.id_estado"
                                            item-text="nombre"
                                            item-value="id"
                                            :items="estados"
                                        >
                                        </v-autocomplete>
                                        <v-autocomplete
                                            v-else
                                            :readonly="readonlyinput"
                                            label="Estado"
                                            v-model="orden.id_estado"
                                            item-text="nombre"
                                            item-value="id"
                                            :items="estados"
                                        >
                                        </v-autocomplete>
                                    </v-col> -->
                                    <v-col cols="12" md="4">
                                        <PresupuestoSelect
                                            :readonly="readonlyinput"
                                            v-model="orden.id_presupuesto"
                                            label="Presupuesto"
                                            :extra="orden.presupuesto"
                                        >
                                        </PresupuestoSelect>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <date-select
                                            :readonly="readonlyinput"
                                            label="Fecha prevista"
                                            v-model="orden.fecha_prevista"
                                        ></date-select>
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <date-select
                                            :readonly="readonlyinput"
                                            label="Fecha finalizada"
                                            v-model="orden.fecha_finalizada"
                                        ></date-select>
                                    </v-col>

                                    <!-- <v-col cols="12" md="2">
                                        <v-autocomplete
                                            :readonly="readonlyinput"
                                            label="Prioridad"
                                            v-model="orden.prioridad"
                                            :items="[1, 2, 3]"
                                        >
                                        </v-autocomplete>
                                    </v-col> 
                                    <v-col cols="12" md="2">
                                        <v-text-field
                                            :readonly="readonlyinput"
                                            v-model="orden.hora"
                                            label="Horas"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field
                                            :readonly="readonlyinput"
                                            disabled
                                            v-model="orden.horas_realizadas"
                                            label="Horas realizadas"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <ordenesSelect
                                            :readonly="readonlyinput"
                                            v-model="orden.orden_relacionada"
                                            label="Obra relacionada"
                                            :extra="orden.orden"
                                            :multiple="true"
                                        >
                                        </ordenesSelect>
                                    </v-col> 
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            :readonly="readonlyinput"
                                            v-model="orden.importe"
                                            label="Importe"
                                            type="number"
                                        ></v-text-field>
                                    </v-col> -->
                                </v-row>

                                <v-row>
                                    <!-- <v-col cols="12" md="3">
                                        <v-switch
                                            :readonly="readonlyinput"
                                            v-model="orden.taller"
                                            label="Taller"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-switch
                                            :readonly="readonlyinput"
                                            v-model="orden.lacado"
                                            label="Lacado"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-switch
                                            :readonly="readonlyinput"
                                            v-model="orden.elevacion"
                                            label="Elevación"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-switch
                                            :readonly="readonlyinput"
                                            v-model="
                                                orden.instalacion_electrica
                                            "
                                            label="Instalación eléctrica"
                                        ></v-switch>
                                    </v-col> -->

                                    <v-col cols="12">
                                        <multiple-select
                                            :readonly="readonlyinput"
                                            :elementos="orden.productos"
                                            title="Productos"
                                            :headers="headers"
                                            @create="createProducto"
                                            @delete="deleteProducto"
                                            @getEstado="getProducto"
                                            @update="updateProducto"
                                        >
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-autocomplete
                                                        v-model="
                                                            producto.id_producto
                                                        "
                                                        :items="productos"
                                                        item-text="titulo"
                                                        item-value="id"
                                                        label="Producto"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" md="6">
                                                    <v-text-field-comma
                                                        type="number"
                                                        v-model="
                                                            producto.precio_hora_normal
                                                        "
                                                        label="Precio hora normal"
                                                        suffix="€"
                                                    >
                                                    </v-text-field-comma>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field-comma
                                                        type="number"
                                                        v-model="
                                                            producto.cantidad_hora_normal
                                                        "
                                                        label="Cantidad de horas"
                                                    >
                                                    </v-text-field-comma>
                                                </v-col>

                                                <v-col cols="12" md="6">
                                                    <v-text-field-comma
                                                        type="number"
                                                        v-model="
                                                            producto.precio_hora_extra
                                                        "
                                                        label="Precio hora nocturna"
                                                        suffix="€"
                                                    >
                                                    </v-text-field-comma>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field-comma
                                                        type="number"
                                                        v-model="
                                                            producto.cantidad_hora_extra
                                                        "
                                                        label="Cantidad de horas nocturnas"
                                                    >
                                                    </v-text-field-comma>
                                                </v-col>

                                                <v-col cols="12" md="6">
                                                    <v-text-field-comma
                                                        type="number"
                                                        v-model="
                                                            producto.precio_hora_festivo
                                                        "
                                                        label="Precio hora festivo"
                                                        suffix="€"
                                                    >
                                                    </v-text-field-comma>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field-comma
                                                        type="number"
                                                        v-model="
                                                            producto.cantidad_hora_festivo
                                                        "
                                                        label="Cantidad de horas festivo"
                                                    >
                                                    </v-text-field-comma>
                                                </v-col>

                                                <v-col cols="12">
                                                    <v-text-field
                                                        type="number"
                                                        v-model="
                                                            producto.precio
                                                        "
                                                        label="Precio"
                                                        suffix="€"
                                                        disabled
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-textarea
                                                        v-model="
                                                            producto.descripcion
                                                        "
                                                        label="Descripción"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </multiple-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <multiple-select
                                            :readonly="readonlyinput"
                                            :headers="headers_contacto"
                                            title="Contacto"
                                            :elementos="orden.contactos"
                                            show="nombre"
                                            @create="createContacto"
                                            @delete="deleteContacto"
                                            @getEstado="updateContactoS"
                                            @update="updateContacto"
                                        >
                                            <v-row>
                                                <v-col cols="12" md="6" class="pr-4 pr-md-5">
                                                    <TipoContactoSelect
                                                        v-model="contacto.tipo"
                                                        :estados="tipoContactos"
                                                        :disabled="readonlyinput"
                                                        :rules="required_val"
                                                        @create="onCreateTipoContacto"
                                                        @update="onUpdateTipoContacto"
                                                        @delete="onDeleteTipoContacto"
                                                    />
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        outlined
                                                        v-model="contacto.nombre"
                                                        label="Nombre"
                                                        :rules="required_val"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        outlined
                                                        v-model="contacto.telefono"
                                                        label="Teléfono"
                                                        type="number"
                                                        :rules="required_val"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        outlined
                                                        v-model="contacto.email"
                                                        label="Email"
                                                        :rules="required_val"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </multiple-select>
                                    </v-col>

                                    <!-- <v-col cols="12">
                                        <FormasPago
                                            :orden="orden"
                                            v-model="orden.metodos"
                                        ></FormasPago>
                                    </v-col> -->

                                    <v-col cols="12">
                                        <v-textarea
                                            outlined
                                            :readonly="readonlyinput"
                                            label="Observaciones"
                                            v-model="orden.observaciones"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-tab-item>

                            <!-- Cliente -->
                            <template v-if="orden.cliente != null">
                                <v-tab v-if="orden.cliente != null"
                                    >Cliente</v-tab
                                >
                            </template>
                            <template v-if="orden.cliente != null">
                                <v-tab-item>
                                    <v-row style="margin-top: 2rem">
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                :readonly="true"
                                                v-model="
                                                    orden.cliente
                                                        .nombre_comercial
                                                "
                                                label="Nombre"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                :readonly="true"
                                                outlined
                                                v-model="orden.cliente.telefono"
                                                label="Teléfono"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                :readonly="true"
                                                outlined
                                                v-model="orden.cliente.telefono"
                                                label="CIF"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                :readonly="true"
                                                outlined
                                                v-model="orden.cliente.email"
                                                label="Email"
                                                required
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                :readonly="true"
                                                outlined
                                                v-model="
                                                    orden.cliente.direccion
                                                        .direccion
                                                "
                                                label="Dirección"
                                                required
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                :readonly="true"
                                                outlined
                                                v-model="
                                                    orden.cliente.direccion
                                                        .codigo_postal
                                                "
                                                type="number"
                                                label="Código postal"
                                                required
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                :readonly="true"
                                                outlined
                                                v-model="
                                                    orden.cliente.direccion
                                                        .ciudad
                                                "
                                                type="text"
                                                label="Población"
                                                required
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="4"
                                            v-if="
                                                orden.cliente.direccion
                                                    .provincia != null
                                            "
                                        >
                                            <v-text-field
                                                :readonly="true"
                                                outlined
                                                v-model="
                                                    orden.cliente.direccion
                                                        .provincia.nombre
                                                "
                                                type="text"
                                                label="Provincia"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-btn
                                                @click="navigate"
                                                :disabled="isloading"
                                                color="primary"
                                                class="white--text"
                                                >Abrir en Google Maps</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </template>

                            <!-- Consumo -->
                            <v-tab v-if="orden.id != null">Consumo</v-tab>
                            <v-tab-item>
                                <FormOrdenConsumoVue
                                    v-model="orden"
                                ></FormOrdenConsumoVue>
                            </v-tab-item>

                            <!-- Archivos -->
                            <v-tab v-if="orden.id != null">Archivos</v-tab>
                            <v-tab-item>
                                <listaArchivos
                                    v-on:delete_archivo="deleteArchivo"
                                    :items="orden.archivo"
                                    @subir_file_64="subirArchivo"
                                >
                                </listaArchivos>
                            </v-tab-item>

                            <!-- Facturas relacionadas a esta obra -->
                            <v-tab v-if="orden.id != null">Facturas</v-tab>
                            <v-tab-item>
                                <v-row class="mt-3">
                                    <v-col cols="12">
                                        <p v-if="!facturasObra.length" class="grey--text">
                                            No hay facturas relacionadas con esta obra.
                                        </p>
                                        <v-data-table
                                            v-else
                                            dense
                                            :headers="headers_facturas_obra"
                                            :items="facturasObra"
                                            :items-per-page="10"
                                            item-key="id"
                                            class="elevation-1"
                                            hide-default-footer
                                        >
                                            <template v-slot:item.fecha="{ item }">
                                                {{ formatFechaFactura(item.fecha) }}
                                            </template>
                                            <template v-slot:item.total_con_iva="{ item }">
                                                {{ formatPriceFactura(item) }}
                                            </template>
                                            <template v-slot:item.ver="{ item }">
                                                <router-link
                                                    :to="`/guardar-factura?id=${item.id}`"
                                                    target="_blank"
                                                    class="text-decoration-none"
                                                >
                                                    <v-icon small color="primary">mdi-pencil</v-icon>
                                                </router-link>
                                            </template>
                                            <template v-slot:item.pdf="{ item }">
                                                <a
                                                    :href="`api/pdf-factura/${item.id}`"
                                                    target="_blank"
                                                    rel="noopener"
                                                >
                                                    <v-icon small color="red">mdi-pdf-box</v-icon>
                                                </a>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-tab-item>

                            <template v-if="!readonlyinput">
                                <!-- Fichajes -->
                                <v-tab v-if="orden.id != null">Fichajes</v-tab>
                                <v-tab-item>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-data-table
                                                dense
                                                :headers="headers_fichaje"
                                                :items="orden.horas_usuarios"
                                                :items-per-page="15"
                                                item-key="id"
                                                class="elevation-1"
                                                :sort-by="['nombre']"
                                                :sort-desc="[false]"
                                            >
                                                <template
                                                    v-slot:item.horas="{ item }"
                                                >
                                                    {{ item.horas }}
                                                </template>
                                                <template
                                                    v-slot:item.horas_extras="{
                                                        item,
                                                    }"
                                                >
                                                    {{ item.horas_extras }}
                                                </template>
                                                <template
                                                    v-slot:item.action="{
                                                        item,
                                                    }"
                                                >
                                                    <v-icon
                                                        @click.stop="
                                                            () => {
                                                                fichaje_dialog = true;
                                                                selectedItem =
                                                                    item;
                                                            }
                                                        "
                                                        small
                                                        class="mr-2 pointer"
                                                        color="#1d2735"
                                                        style="font-size: 25px"
                                                        title="EDITAR"
                                                        >mdi-pencil</v-icon
                                                    >
                                                    <!--router-link
                                                        :to="{ path: `/guardar-orden?id=${item.id}` }"
                                                        class="action-buttons"
                                                    >
                                                        <v-icon
                                                            small
                                                            class="mr-2"
                                                            color="#1d2735"
                                                            style="font-size: 25px"
                                                            title="EDITAR"
                                                            >mdi-pencil-outline</v-icon
                                                        >
                                                    </!--router-link-->
                                                    <v-icon
                                                        @click.stop="
                                                            openDeleteModal(
                                                                item.id
                                                            )
                                                        "
                                                        small
                                                        class="mr-2"
                                                        color="red"
                                                        style="font-size: 25px"
                                                        title="BORRAR"
                                                        >mdi-trash-can</v-icon
                                                    >

                                                    <!--v-icon @click="openModal(item)" small class="mr-2" color="red" style="font-size: 25px;" title="BORRAR">mdi-trash-can</!--v-icon-->
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>

                                <!-- Pedidos -->
                                <v-tab v-if="orden.id != null">Pedidos</v-tab>
                                <v-tab-item>
                                    <ListaPedido
                                        :id_orden_ext="orden.id"
                                        :showFilters="true"
                                    ></ListaPedido>
                                </v-tab-item>
                            </template>
                        </v-tabs>

                        <v-row>
                            <v-col cols="12">
                                <router-link
                                    :to="
                                        rol == 6
                                            ? 'lista-plan-orden'
                                            : 'lista-ordenes'
                                    "
                                >
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>

                                <v-btn
                                    v-if="rol == 1 || rol == 9"
                                    @click="updateorden"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >{{
                                        orden.id != null
                                            ? "Actualizar"
                                            : "Guardar"
                                    }}</v-btn
                                >
                                <a
                                    v-if="orden.id != null"
                                    target="_blank"
                                    :href="`/api/pdf-orden/${orden.id}`"
                                >
                                    <v-btn
                                        color="primary"
                                        class="white--text mr-2"
                                    >
                                        Imprimir
                                    </v-btn>
                                </a>
                                <template v-if="!readonlyinput">
                                    <v-btn
                                        color="primary"
                                        class="white--text mr-2"
                                        @click="plan_dialog = true"
                                    >
                                        Generar planificación
                                    </v-btn>
                                    <router-link
                                        v-if="orden.id_presupuesto != null"
                                        :to="`guardar-presupuesto-cliente?id=${orden.id_presupuesto}`"
                                    >
                                        <v-btn
                                            color="primary"
                                            class="white--text"
                                        >
                                            Ver presupuesto
                                        </v-btn>
                                    </router-link>
                                </template>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="plan_dialog" max-width="1000px">
            <FormPlan v-model="orden.id"></FormPlan>
        </v-dialog>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteOrden()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <FichajeManualDialog
            @Saved="SavedFichajeManual"
            v-model="fichaje_dialog"
            :fichaje="selectedItem"
            :orden="orden"
        ></FichajeManualDialog>

        <!-- Formulario de nuevo fichaje -->
        <FormOrdenFichaje
            v-model="isNewFichajeVisible"
            @refresh="getorden(orden.id)"
        ></FormOrdenFichaje>
    </v-container>
</template>

<script>
import listaArchivos from "../../../components/general/listaArchivos.vue";
import FormOrdenConsumoVue from "./FormOrdenConsumo.vue";
import ordenesSelect from "../../../components/general/ordenesSelect.vue";
import clienteSelect from "../../../components/general/clienteSelect.vue";
import PresupuestoSelect from "../../../components/general/PresupuestoSelect.vue";
import FormPlan from "./FormPlan.vue";
import ListaPedido from "../../PedidoProveedor/componentes/ListaPedido.vue";
import FormasPago from "./FormasPago.vue";
import FichajeManualDialog from "./FichajeManualDialog.vue";
import { rules } from "../../../rules/validation_rules";
import FormOrdenFichaje from "./FormOrdenFichaje.vue";
import TipoContactoSelect from "../../../components/general/TipoContactoSelect.vue";

export default {
    components: {
        FormOrdenConsumoVue,
        listaArchivos,
        ordenesSelect,
        clienteSelect,
        FormPlan,
        PresupuestoSelect,
        ListaPedido,
        FormasPago,
        FichajeManualDialog,
        FormOrdenFichaje,
        TipoContactoSelect,
    },
    data() {
        return {
            rules: rules,
            fichaje_dialog: false,
            plan_dialog: false,
            dialog: false,
            selectedItem: {},
            id: null,
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            tab: 0,
            producto: {
                id_orden: null,
                id_producto: null,
                id_elemento: null,
                precio: 0,
                precio_hora_normal: 0,
                cantidad_hora_normal: 0,
                precio_hora_extra: 0,
                cantidad_hora_extra: 0,
                precio_hora_festivo: 0,
                cantidad_hora_festivo: 0,
                descripcion: null,
            },

            headers_facturas_obra: [
                { text: "Nº", value: "nro", sortable: false },
                { text: "Serie", value: "serie_nombre", sortable: false },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Total (con IVA)", value: "total_con_iva", sortable: false },
                { text: "Ver", value: "ver", sortable: false, width: "60" },
                { text: "PDF", value: "pdf", sortable: false, width: "60" },
            ],
            headers_fichaje: [
                {
                    text: "Usuario",
                    value: "usuario",
                    sortable: false,
                },
                {
                    text: "Horas",
                    value: "horas",
                    sortable: false,
                },
                {
                    text: "Horas nocturnas",
                    value: "horas_extras",
                    sortable: false,
                },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],

            Ordenes: [],
            menu: false,
            productos: [],
            orden: {
                id: null,
                nombre: "",
                email: "",
                telefono: "",
                direccion: "",
                orden_relacionada: [],
                metodos: [],
                contactos: [],
            },
            contacto: {},
            index_contacto: null,
            headers_contacto: [
                { text: "Tipo", value: "tipo", sortable: false },
                { text: "Nombre", value: "nombre", sortable: false },
                { text: "Teléfono", value: "telefono", sortable: false },
                { text: "Email", value: "email", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            tipoContactos: [
                { id: 0, nombre: "Comercial" },
                { id: 1, nombre: "Facturación" },
            ],
            nextTipoId: 2,
            presupuestos: [],
            // tipos: [],
            // estados: [],
            index_producto: 0,
            id_producto_original: null, // Guardar el id_producto original al editar
            isNewFichajeVisible: false,
        };
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        "orden.id_presupuesto"(val) {
            // if (val) {
            //     this.orden.presupuesto = this.presupuestos.find(e => e.id == this.orden.id_presupuesto);
            // }
            // console.log('Prespuesto select', this.presupuestos)
            this.getpresupuesto(val);
        },
        "producto.id_producto"(val, oldVal) {
            if (val && val !== oldVal) {
                // Verificar si estamos editando un producto existente
                const estaEditando = this.index_producto !== null;

                // Si estamos editando, verificar si el producto realmente cambió
                // comparando con el id_producto original guardado
                const productoRealmenteCambio = estaEditando
                    ? val !== this.id_producto_original
                    : true; // Si no estamos editando, siempre actualizar

                const productoFind = this.productos.find((e) => e.id == val);

                if (productoFind && productoRealmenteCambio) {
                    // Actualizar valores base del nuevo producto seleccionado
                    this.producto.precio_hora_normal =
                        productoFind?.precio_hora_normal ?? 0;
                    this.producto.cantidad_hora_normal =
                        productoFind?.cantidad_hora_normal ?? 0;
                    this.producto.precio_hora_extra =
                        productoFind?.precio_hora_extra ?? 0;
                    this.producto.cantidad_hora_extra =
                        productoFind?.cantidad_hora_extra ?? 0;
                    this.producto.precio_hora_festivo =
                        productoFind?.precio_hora_festivo ?? 0;
                    this.producto.cantidad_hora_festivo =
                        productoFind?.cantidad_hora_festivo ?? 0;

                    // Calcular precio inicial
                    this.calcularPrecioTotal();
                } else if (estaEditando && !productoRealmenteCambio) {
                    // Si estamos editando y el producto no cambió (primera carga),
                    // solo recalcular con valores existentes
                    this.calcularPrecioTotal();
                }
            }
        },
        // Watcher para recalcular precio cuando cambian precios o cantidades
        "producto.precio_hora_normal"() {
            this.calcularPrecioTotal();
        },
        "producto.cantidad_hora_normal"() {
            this.calcularPrecioTotal();
        },
        "producto.precio_hora_extra"() {
            this.calcularPrecioTotal();
        },
        "producto.cantidad_hora_extra"() {
            this.calcularPrecioTotal();
        },
        "producto.precio_hora_festivo"() {
            this.calcularPrecioTotal();
        },
        "producto.cantidad_hora_festivo"() {
            this.calcularPrecioTotal();
        },
    },
    created() {
        this.getProductos();
        this.getPresupuestos();
        // this.getTipos();
        // this.getEstados();
        if (this.$route.query.id) {
            this.getorden(this.$route.query.id);
        }
    },
    methods: {
        // Get orden by id
        getorden(orden_id) {
            axios.get(`api/get-orden/${orden_id}`).then(
                (res) => {
                    this.orden = res.data;
                    if (!this.orden.contactos) this.orden.contactos = [];
                    if (!this.orden.facturas) this.orden.facturas = [];
                    this.incorporarTiposContactoExistentes();
                    this.orden.orden;
                    this.isNewFichajeVisible = false;
                },
                (res) => {}
            );
        },
        formatFechaFactura(fecha) {
            if (!fecha) return "";
            const s = String(fecha).split("T")[0];
            const p = s.split("-");
            return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
        },
        formatPriceFactura(item) {
            const v = item.total_con_iva != null ? item.total_con_iva : item.total;
            if (v == null || isNaN(v)) return "";
            return Number(v)
                .toFixed(2)
                .replace(".", ",")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        // Actualizar orden
        updateorden() {
            // console.log('orden', this.orden)
            if (!this.$refs.form.validate()) {
                this.$toast.error("Revise los campos requeridos");

                return;
            }
            //return;
            axios
                .post("api/save-orden", this.orden)
                .then((res) => {
                    this.orden = res.data;
                    // console.log(this.orden);
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        // Eliminar orden
        deleteorden() {
            axios.post("api/delete-orden", { id: this.orden.id }).then(
                (res) => {
                    this.$router.push("lista-ordenes");
                },
                (res) => {}
            );
        },

        // Acciones de fichajes de la orden
        Fichar(detener) {
            axios
                .post(`api/fichar-orden/${this.orden.id}`, {
                    detener: false,
                })
                .then(
                    (res) => {
                        this.orden.fichajes = res.data.ordenes;
                        this.orden.fichajes_count = res.data.length;
                        this.orden.horas_realizadas = res.data.horas;
                        this.orden.id_estado = res.data.estado;
                        this.orden.horas_usuarios = res.data.horas_usuarios;
                    },
                    (res) => {}
                );
        },

        // Eliminar fichaje de la orden
        openFormOrdenFichaje() {
            // console.log("openFormOrdenFichaje");
            this.isNewFichajeVisible = true;
        },
        openDeleteModal(id) {
            this.dialog = true;
            this.id = id;
        },
        deleteOrden() {
            axios.delete(`api/delete-orden-fichaje/${this.id}`).then(
                (res) => {
                    this.getorden(this.$route.query.id);
                    this.dialog = false;
                },
                (res) => {}
            );
        },

        // Get presupuesto by id segun el id_presupuesto de la orden
        getpresupuesto(id) {
            axios.get(`api/get-presupuestos?withData=${1}&id=${id}`).then(
                (res) => {
                    // console.log("presupuestos", res.data.Presupuestos);
                    let i = 0;
                    this.orden.metodos = res.data.Presupuestos?.metodos_pago;
                    // console.log("me", this.orden.metodos);
                },
                (err) => {
                    this.$custom_error("Error consultando el presupuesto");
                }
            );
        },

        // Metodos generales
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getPresupuestos() {
            axios.get(`api/get-presupuestos?validacion=${0}`).then(
                (res) => {
                    this.presupuestos = res.data.Presupuestos;
                },
                (err) => {
                    this.$custom_error("Error consultando los presupuestos");
                }
            );
        },

        SavedFichajeManual(data) {
            this.getorden(this.$route.query.id);
        },

        // Acciones de productos de la orden (tab datos de la orden)
        /*
            @create="createProducto"
            @delete="deleteProducto"
            @getEstado="getProducto"
            @update="updateProducto"
        */
        createProducto() {
            const producto = this.productos.find(
                (element) => element.id == this.producto.id_producto
            );
            if (producto) {
                this.producto.producto = producto;
                this.producto.nombre = producto.nombre;
                this.producto.titulo = producto.titulo;
                // Los valores de precio y cantidad ya están establecidos por el watcher
                // Solo asegurar que el precio total esté calculado
                this.calcularPrecioTotal();
            }

            if (this.orden.productos == null) this.orden.productos = [];
            this.orden.productos.push({ ...this.producto });
            this.clearProducto();
        },
        deleteProducto(index) {
            this.orden.productos.splice(index, 1);
        },
        getProducto(index) {
            // Establecer index_producto ANTES de cargar el producto
            // para que el watcher sepa que estamos editando
            this.index_producto = index;
            if (index != null) {
                // Cargar el producto con todos sus valores guardados
                const productoGuardado = JSON.parse(
                    JSON.stringify(this.orden?.productos[index])
                );
                // Guardar el id_producto original para detectar cambios posteriores
                this.id_producto_original = productoGuardado.id_producto;
                this.producto = productoGuardado;
                // Recalcular el precio total con los valores cargados
                this.calcularPrecioTotal();
            } else {
                this.clearProducto();
            }
        },
        updateProducto() {
            // Asegurar que el precio total esté calculado con los valores actuales
            this.calcularPrecioTotal();

            // Obtener referencia al producto base para mantener nombre y titulo
            const producto = this.productos.find(
                (element) => element.id == this.producto.id_producto
            );

            if (producto) {
                // Mantener referencia al producto base (nombre, titulo)
                this.producto.producto = producto;
                this.producto.nombre = producto.nombre;
                this.producto.titulo = producto.titulo;
                // NO sobrescribir los valores de precio y cantidad que el usuario editó
            }

            // Actualizar el producto en el array
            this.orden.productos[this.index_producto] = { ...this.producto };

            // Forzar reactividad
            const productos = JSON.parse(JSON.stringify(this.orden.productos));
            this.orden.productos = null;
            this.orden.productos = productos;

            this.clearProducto();
        },
        clearProducto() {
            this.producto = {
                id_orden: null,
                id_producto: null,
                id_elemento: null,
                precio: 0,
                precio_hora_normal: 0,
                cantidad_hora_normal: 0,
                precio_hora_extra: 0,
                cantidad_hora_extra: 0,
                precio_hora_festivo: 0,
                cantidad_hora_festivo: 0,
                descripcion: null,
            };
            // Resetear index_producto y id_producto_original para indicar que no estamos editando
            this.index_producto = null;
            this.id_producto_original = null;
        },

        // Contactos de la obra
        incorporarTiposContactoExistentes() {
            if (!this.orden.contactos || !Array.isArray(this.orden.contactos)) return;
            this.orden.contactos.forEach((c) => {
                const nombre = c.tipo && typeof c.tipo === "string" ? c.tipo.trim() : "";
                if (!nombre) return;
                const existe = this.tipoContactos.some((t) => t.nombre === nombre);
                if (!existe) {
                    this.tipoContactos.push({ id: this.nextTipoId++, nombre });
                }
            });
            this.tipoContactos.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
        },
        updateContactoS(index) {
            this.contacto = JSON.parse(JSON.stringify(this.orden.contactos[index]));
            this.index_contacto = index;
        },
        createContacto() {
            if (!this.orden.contactos) this.orden.contactos = [];
            this.orden.contactos.push(JSON.parse(JSON.stringify(this.contacto)));
        },
        updateContacto() {
            this.orden.contactos[this.index_contacto] = JSON.parse(JSON.stringify(this.contacto));
        },
        deleteContacto(index) {
            if (!this.orden.contactos_eliminados) this.orden.contactos_eliminados = [];
            if (this.orden.contactos[index].id != null) {
                this.orden.contactos_eliminados.push(this.orden.contactos[index].id);
            }
            this.orden.contactos.splice(index, 1);
        },
        onCreateTipoContacto(nombre) {
            const n = (nombre || "").trim();
            if (!n || this.tipoContactos.some((t) => t.nombre === n)) return;
            this.tipoContactos.push({ id: this.nextTipoId++, nombre: n });
            this.tipoContactos.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
            // Asignar el nuevo tipo al contacto actual para que quede seleccionado en el select
            if (this.contacto && typeof this.contacto === "object") {
                this.$set(this.contacto, "tipo", n);
            }
        },
        onUpdateTipoContacto(item) {
            const idx = this.tipoContactos.findIndex((t) => t.id === item.id);
            if (idx === -1) return;
            const antiguo = this.tipoContactos[idx].nombre;
            const nuevo = (item.nombre || "").trim();
            if (!nuevo || (nuevo !== antiguo && this.tipoContactos.some((t) => t.nombre === nuevo))) return;
            this.tipoContactos[idx].nombre = nuevo;
            this.tipoContactos.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
            if (this.orden.contactos && Array.isArray(this.orden.contactos)) {
                this.orden.contactos.forEach((c) => {
                    if (c.tipo === antiguo) c.tipo = nuevo;
                });
            }
        },
        onDeleteTipoContacto(id) {
            const idx = this.tipoContactos.findIndex((t) => t.id === id);
            if (idx === -1) return;
            const nombreBorrado = this.tipoContactos[idx].nombre;
            this.tipoContactos.splice(idx, 1);
            if (this.orden.contactos && Array.isArray(this.orden.contactos)) {
                this.orden.contactos.forEach((c) => {
                    if (c.tipo === nombreBorrado) c.tipo = "";
                });
            }
            if (this.contacto && this.contacto.tipo === nombreBorrado) this.contacto.tipo = "";
        },
        calcularPrecioTotal() {
            // Calcular precio total basado en los valores actuales de precios y cantidades
            const precioNormal =
                (this.producto.precio_hora_normal || 0) *
                (this.producto.cantidad_hora_normal || 0);
            const precioExtra =
                (this.producto.precio_hora_extra || 0) *
                (this.producto.cantidad_hora_extra || 0);
            const precioFestivo =
                (this.producto.precio_hora_festivo || 0) *
                (this.producto.cantidad_hora_festivo || 0);

            this.producto.precio = precioNormal + precioExtra + precioFestivo;
        },
        navigate() {
            let lat = this.orden.cliente.latitud;
            let lng = this.orden.cliente.longitud;
            if (lat == null) {
                lat = this.orden.cliente.direccion.lat;
                lng = this.orden.cliente.direccion.lon;
            }
            // If it's an iPhone..
            if (
                navigator.platform.indexOf("iPhone") !== -1 ||
                navigator.platform.indexOf("iPod") !== -1
            ) {
                function iOSversion() {
                    if (/iP(hone|od|ad)/.test(navigator.platform)) {
                        // supports iOS 2.0 and later
                        var v = navigator.appVersion.match(
                            /OS (\d+)_(\d+)_?(\d+)?/
                        );
                        return [
                            parseInt(v[1], 10),
                            parseInt(v[2], 10),
                            parseInt(v[3] || 0, 10),
                        ];
                    }
                }
                var ver = iOSversion() || [0];

                var protocol = "http://";
                if (ver[0] >= 6) {
                    protocol = "maps://";
                }
                window.location =
                    protocol +
                    "maps.apple.com/maps?daddr=" +
                    lat +
                    "," +
                    lng +
                    "&amp;ll=";
            } else {
                window.open(
                    "http://maps.google.com?daddr=" +
                        lat +
                        "," +
                        lng +
                        "&amp;ll="
                );
            }
        },

        // Acciones de archivos de la orden (tab archivos de la orden)
        deleteArchivo(archivo) {
            axios.get(`api/delete-archivo-orden/${archivo.id}`).then(
                (res) => {
                    this.orden.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        subirArchivo(data) {
            axios
                .post(`api/save-archivo-orden`, {
                    id: this.orden.id,
                    archivo: data.data,
                    nombre: data.nombre,
                    extension: data.extension,
                })
                .then((res) => {
                    this.orden.archivo = res.data;
                });
        },
        redirect() {
            const fromCliente = this.$route.query.from === "cliente";
            const idCliente = this.$route.query.id_cliente || (this.orden && this.orden.id_cliente);
            if (fromCliente && idCliente != null) {
                this.$router.push(`/guardar-cliente?id=${idCliente}&tab=4`);
                return;
            }
            if (this.$route.query.cal == 1) {
                this.$router.push("calendario-plan-orden");
            } else if (this.rol == 6) {
                this.$router.push("lista-plan-orden");
            } else {
                this.$router.push("lista-ordenes");
            }
        },

        // En desuso
        /*save(date) {
            this.$refs.menu.save(date);
        },
        saveorden() {
            axios
                .post("api/save-orden", this.orden)
                .then((res) => {
                    this.orden = res.data;
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        getTipos() {
            axios.get(`api/get-tipos-orden`).then(
                (res) => {
                    this.tipos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los tipos");
                }
            );
        },
        getEstados() {
            axios.get(`api/get-estados-orden`).then(
                (res) => {
                    this.estados = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los estados");
                }
            );
        },*/
    },
    filters: {},
    computed: {
        headers() {
            let headers = [
                {
                    text: "Producto",
                    value: "producto.nombre",
                    sortable: false,
                },
                {
                    text: "Descripción",
                    value: "descripcion",
                    sortable: false,
                },
                {
                    text: "Precio total",
                    value: "precio",
                    sortable: false,
                },
            ];
            if (!this.readonlyinput) {
                headers.push({
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                });
            }
            return headers;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
        rol: function () {
            return localStorage.getItem("role");
        },
        readonlyinput: function () {
            const rol = this.rol;
            return rol == 6 || rol == 7;
        },
        facturasObra() {
            return (this.orden.facturas || []).map((f) => ({
                ...f,
                total_con_iva:
                    f.nota == 1
                        ? f.total
                        : Number((f.total * (1 + (f.iva || 0) / 100)).toFixed(2)),
            }));
        },
    },
};
</script>
